import type { HelpFile } from '../../types/help'
import { AccessSnapshotViewTestIds } from '../../../testids/AccessSnapshotViewTestIds'

export const accessSnapshotViewHelp: HelpFile = {
  docPage: '/docs/effective-access/snapshot',
  texts: {
    [AccessSnapshotViewTestIds.colEntitlement]: 'Der Identität gewährtes Zugriffsprofil.',
    [AccessSnapshotViewTestIds.colOperation]: 'Operation, die die Identität auf der Ressource ausführen darf — z. B. Lesen, Schreiben oder Verwalten.',
    [AccessSnapshotViewTestIds.colResource]: 'Ressource, auf die sich dieser Zugriff bezieht.',
    [AccessSnapshotViewTestIds.colSource]: 'Herkunft dieses Zugriffs — direkt, über eine Rolle, Funktionsgruppe oder Auto-Zuweisungsregel.',
    [AccessSnapshotViewTestIds.colValidUntil]: 'Ablaufdatum dieser Zugriffsvergabe — leer bedeutet unbefristet.',
  },
}
